import { combineReducers } from 'redux';
import authReducers from './authReducers';
import progressReducers from './progressReducers';
import userReducers from './userReducers';
import profileReducer from './profileReducers';
import rolesReducers from './rolesReducers';
import editUserRoles from './editUserRolesReducers';

const rootReducer = combineReducers({
  auth: authReducers,
  progress: progressReducers,
  users: userReducers,
  profile: profileReducer,
  roles: rolesReducers,
  editUserRoles: editUserRoles
});

export default rootReducer;
